module.exports = __webpack_public_path__ + "assets/calculator.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/calculator.png
// module id = 1205
// module chunks = 7